import z from "zod";
import {
  FloorPlanDecorationIdScheme,
  FloorPlanIdScheme,
  FloorPlanTableIdScheme,
} from "./ids";
import { FloorPlanDecorationType } from "./enums/FloorPlanDecorationType";
import { FloorPlanTableType } from "./enums/FloorPlanTableType";

export const FloorPlanTableScheme = z.object({
  id: FloorPlanTableIdScheme,
  name: z.string(),
  type: z.enum(FloorPlanTableType),
  x: z.number().optional(),
  y: z.number().optional(),
  width: z.number().positive().optional(),
  height: z.number().positive().optional(),
  rotation: z.number().optional(),
});

export const FloorPlanDecorationScheme = z.object({
  id: FloorPlanDecorationIdScheme,
  type: z.enum(FloorPlanDecorationType),
  name: z.string().optional(),
  x: z.number().optional(),
  y: z.number().optional(),
  width: z.number().positive().optional(),
  height: z.number().positive().optional(),
  rotation: z.number().optional(),
});

export const FloorPlanDBScheme = z.object({
  id: FloorPlanIdScheme,
  name: z.string(),
  sortOrder: z.number().int(),
  mapEnabled: z.boolean(),
  mapWidth: z.number().positive(),
  mapHeight: z.number().positive(),
  tables: z.array(FloorPlanTableScheme),
  decorations: z.array(FloorPlanDecorationScheme),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetFloorPlan = FloorPlanDBScheme;

export const RestCreateFloorPlan = FloorPlanDBScheme.omit({
  id: true,
  sortOrder: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdateFloorPlan = FloorPlanDBScheme.omit({
  id: true,
  sortOrder: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type DBFloorPlan = z.infer<typeof FloorPlanDBScheme>;
export type RestFloorPlan = z.infer<typeof RestGetFloorPlan>;
export type RestCreateFloorPlanType = z.infer<typeof RestCreateFloorPlan>;
export type RestUpdateFloorPlanType = z.infer<typeof RestUpdateFloorPlan>;
export type FloorPlanTable = z.infer<typeof FloorPlanTableScheme>;
export type FloorPlanDecoration = z.infer<typeof FloorPlanDecorationScheme>;
